var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeP2Bg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 794,
    height: 240,
    viewBox: "0 0 794 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_21699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 794,
    height: 240
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0208282 0H793.313V240H0.0208282V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_21699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_316_21699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -80,
    y: -621,
    width: 954,
    height: 1349
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M873.4 -620.3H-79.4V727.3H873.4V-620.3Z",
    fill: "black",
    fillOpacity: 0.55
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_316_21699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_316_21699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 794,
    height: 240
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M793.333 0H-3.05176e-05V240H793.333V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_316_21699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_316_21699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 794,
    height: 239
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0207977 0.984375H793.312V238.969H0.0207977V0.984375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_316_21699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-63.1875 0.984375H856.224V238.969H-63.1875V0.984375Z",
    fill: "#705CE3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeP2Bg);
export default __webpack_public_path__ + "static/media/home_p2_bg.af4efc4199c7dc3a94c053b78b8615a6.svg";
export { ForwardRef as ReactComponent };